import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'xgeeks-gitlab-commits-plugin',
});
